import React from "react";
import MemberModal from "./components/MemberModal";

// import david from "./images/david3.jpeg";

const HumanPractices = ({ fontSize }) => {
  return (
    <div>
      <div className="humanDiv membersDiv ">
        <div className="cardContainer grid-container">
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Amberlee Morgan "
            program="Honours Biology "
            term="2A "
            bird="Perpetually Tired "
            lab="Titration burette "
            travel="Nunavut "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/amberlee-morgan-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/amberlee-morgan-silly.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Brianna Thomas "
            program="Science and Business "
            term="2A "
            bird="Night Owl "
            lab=" "
            travel="Greece "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/brianna-thomas-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/brianna-thomas-profile.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Dawson McLachlan "
            program="Biochemistry "
            term="2B "
            bird="Perpetually Tired "
            lab="Centrifuge "
            travel="Scotland "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/dawson-mclachlan-profile.jpeg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/dawson-mclachlan-silly.jpeg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Denver Winch "
            program="Science and Business with Biotechnology Specialization "
            term="2B "
            bird="Early Bird "
            lab="Micropipette "
            travel="Peru or Egypt"
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/denver-winch-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/denver-winch-profile.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Dorothy Lin "
            program="Honours Science "
            term="3A "
            bird="Perpetually Tired "
            lab=" "
            travel="Japan "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/dorothy-lin-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/dorothy-lin-profile.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Jackie Easson "
            program="Biochemistry "
            term="2B "
            bird="Early Bird "
            lab="pipette "
            travel="Iceland "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/human-practices-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/jackie-easson-silly.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Joshua Khatri "
            program="Biology "
            term="2B "
            bird="Night Owl "
            lab="Stir bar "
            travel="India"
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/joshua-khatri-profile.jpeg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/joshua-khatri-silly.jpeg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Molly Lu "
            program="Honours Biology "
            term="4A "
            bird="Night Owl "
            lab="Petri dish "
            travel="Edinburgh "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/molly-lu-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/molly-lu-silly.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Sophia Tan "
            program="Honours Biology "
            term="4A "
            bird="Early Bird "
            lab="Bunsen burner "
            travel="Switzerland "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/sophia-tan-profile.jpeg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/sophia-tan-silly.jpeg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Steven Zhang "
            program="Honours Science "
            term="3A "
            bird="Night Owl "
            lab="Alcohol burner "
            travel="Japan "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/steven-zhang-profile.jpg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/steven-zhang-silly.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Human Practices"
            name="Tammy Huynh "
            program="Life Sciences "
            term="3B "
            bird="Perpetually Tired "
            lab="Goggles "
            travel="Japan "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/tammy-huynh-profile.jpeg "
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/tammy-huynh-profile.jpeg "
            }
          />
        </div>
      </div>
    </div>
  );
};

export default HumanPractices;
